import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import {
  TextInput, SPassword as _Password, Button, HelpBlock, Hint, InputContainer,
} from '../common/styles';
import FullName from '../../shared/sign-up/full-name';
import Email from '../../shared/sign-up/email';
import Password from '../../shared/sign-up/password';
import Loading from '../../../shared/loading';
import { useForm } from '../../../shared/form-validator-hook';
import useRegister from '../../shared/sign-up/hooks';
import oauthProviderDisplayName from '../../shared/sign-up/oauth-provider-label';
import { recordEvent } from '../../../services/events-service';

const ErrorMessage = styled(HelpBlock)`
  &&&& {
    display: inline;
  }
`;

/* stylelint-disable selector-type-no-unknown */
const SPassword = styled(_Password)`
  &&[data-error="show"] + span.icon-lw + ${HelpBlock} + ${Hint} {
    display: none;
  }
`;
/* stylelint-enable selector-type-no-unknown */

export default function SignUpForm() {
  const { redirectTo } = React.useContext(ThemeContext);
  const loadingRef = React.useRef();
  const [useLazy, setUseLazy] = React.useState(true);
  const params = new URLSearchParams(window.location.search);
  const email = params.get('email');
  const {
    values, useInput, errors, validateForm,
  } = useForm({ fullName: '', email, password: '' }, { lazy: useLazy });
  const {
    isEmailUnique, isLoading, oauthProvider, start,
  } = useRegister({
    doSubscription: false,
    data: values,
    onEmailNotUnique: () => loadingRef.current.stop(),
    onComplete: () => {
      let url;
      try {
        url = new URL(redirectTo);
        window.location = redirectTo;
      } catch (_) {
        url = new URL(`${window.location.origin}${redirectTo}`);
        url.searchParams.append('time', Date.now());
        window.location = url.toString();
      }
    },
  });
  const commonProps = {
    Field: TextInput,
    Err: HelpBlock,
    useInput,
    errors,
  };

  React.useEffect(() => {
    if (isLoading) {
      loadingRef.current.start();
    }
  }, [isLoading]);

  const submit = e => {
    e && e.preventDefault();
    recordEvent({
      event: 'sign_up_with_livewire',
      id: 0,
      statisticable: 'navigation',
      page: '/sign_up',
    });

    if (validateForm()) {
      start();
    } else {
      setUseLazy(false);
    }
  };

  return (
    <React.Fragment>
      <InputContainer>
        <FullName {...commonProps} focus />
      </InputContainer>
      <InputContainer>
        <Email {...commonProps} />
        {(!errors.email && !isEmailUnique) && (
          <ErrorMessage>
            {oauthProvider ? (
              <>
                Email is active using
                {' '}
                {oauthProviderDisplayName(oauthProvider)}
                {' '}
                oAuth.
                {' '}
                <a href="/sign_in">Sign In</a>
                {' '}
                to access.
              </>
            ) : (
              <>
                Email already in use.
                {' '}
                <a href="https://www.livewiremarkets.com/sign_in">Sign In</a>
                {' '}
                to access your account.
              </>
            )}
          </ErrorMessage>
        )}
      </InputContainer>
      <InputContainer>
        <Password {...commonProps} Field={SPassword} peekaboo />
        <Hint>Password requires at least 8 characters and 1 digit</Hint>
      </InputContainer>
      <InputContainer>
        <Loading variant="button" ref={loadingRef}>
          <Button type="button" onClick={submit}>join free</Button>
        </Loading>
      </InputContainer>
    </React.Fragment>
  );
}
